import styled from 'styled-components';

export const StyledTopBar = styled.div`
  display: flex;
  width: 100%;
  font-weight: 700;
  justify-content: space-between;
  align-items: center;
`;

export const StyledNavBar = styled.div`
  font-size: 12px;
  padding-top: 5px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .ant-checkbox-wrapper {
    font-size: 12px;
  }

  .anticon-caret-down {
    vertical-align: 0;
  }
`;

export const StyledButtons = styled.div`
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  button {
    margin: 0 0 0 10px;
  }
`;

export const StyledTitle = styled.div`
  font-size: 12px;
  padding: 5px 0;
`;

export const StyledCommentWrapper = styled.div`
  .ant-form-item {
    margin-bottom: 10px;
  }

  .ant-comment-inner {
    padding: 0;
  }

  .ant-spin-container {
    max-height: 150px;
    overflow-y: auto;
  }

  textarea {
    resize: none;
    border: 1px solid #c4c4c4;
    box-shadow: none !important;
  }

  .ant-input-data-count {
    float: left;
  }

  .ant-list-header {
    border: none;
  }
`;

export const StyledWrapper = styled.div`
  .ant-divider-horizontal {
    margin: 3px 0;
  }
`;

export const StyledCommentListWrapper = styled.div`
  .ant-comment-actions {
    position: absolute;
    right: 0;
    top: 0;
  }
`;

export const StyledComment = styled.div`
  border-bottom: 1px solid #e6e6e6;
  margin-bottom: 7px;

  .ant-comment-content-author > a,
  .ant-comment-content-author > span {
    color: #000;
  }

  .ant-comment-content-detail {
    color: #4a4a4a;
    font-size: 12px;
    margin-bottom: 2px;
  }
`;

export const StyledNavRight = styled.div`
  button {
    font-size: 12px;
  }

  .anticon {
    font-size: 18px;
    vertical-align: 0;
    margin: 0 0 0 5px;
  }
`;

export const StyledInfoIcon = styled.span`
  .anticon {
    font-size: 18px;
    vertical-align: 0;
  }
`;

export const StyledCommentBox = styled.div`
  border-top: 1px solid #e6e6e6;
  margin-bottom: 7px;
`;

export const StyledDeleteButton = styled.div`
  float: right;
  margin-right: 10px;
`;
